import { Box, Button, HStack, StackProps, Text } from "@chakra-ui/react";
import { useState } from "react";

type Props = StackProps & {
  value: string;
};

export default function ExpandableTextCell({ value, ...rest }: Props) {
  const [showFull, setShowFull] = useState(false);
  const isOverLimit = value.length > 240;
  const limitedValue = value.slice(0, 240);

  return (
    <HStack align="flex-start" fontSize="sm" spacing={0.5} {...rest}>
      <Text as="span" color="dimmed">
        &quot;
      </Text>
      <Box>
        <Box as="span" mr={isOverLimit ? 2 : undefined}>
          <Text as="span">
            {!isOverLimit || showFull ? value : `${limitedValue}...`}
          </Text>
          {(!isOverLimit || showFull) && (
            <Text as="span" color="dimmed" ml={0.5}>
              &quot;
            </Text>
          )}
        </Box>
        {isOverLimit && (
          <Button
            color="dimmed"
            fontSize="xs"
            type="button"
            variant="link"
            onClick={() => setShowFull((cur) => !cur)}
          >
            {showFull ? "Show less" : "Show more"}
          </Button>
        )}
      </Box>
    </HStack>
  );
}
